import { useMutation } from '@tanstack/react-query';

import { json_headers, request } from '~/services/common';

import { encodeRequestBody } from '~/utils/encodeRequestBody';
import { resolveReportingLeDataUrl } from '~/utils/resolveReportingLeDataUrl';

export function useReplyPageBridge() {
  return useMutation({
    mutationFn: async ({
      requestId,
      connectionId,
      result,
    }: {
      requestId: string;
      connectionId: string;
      result: unknown;
    }) => {
      await request(
        resolveReportingLeDataUrl(`/api/reporting/le-data/page-bridge/${encodeURIComponent(requestId)}/result`),
        {
          method: 'POST',
          headers: json_headers,
          body: JSON.stringify(encodeRequestBody({ connectionId, result })),
          ignoreResponse: true,
        },
      );
    },
  });
}
